import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  SIDENAV_KEYS,
  RECIPTS_KEYS,
  AUTH_KEYS,
  VALIDATION_MESSAGES,
} from '../../utils/translation-constants'
import '../../index.css'
import { carouselCurrentItemSelector } from '../../selectors'
import Loading from 'custom/assets/loaders/Loading'
import BeneficiaryTransferService from '../../services/beneficiary-transfers.service'
import moment from 'moment'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import TransferReceipts from './transferReceipts'
import PaymentReceipts from './paymentReceipts'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import Pagination from 'react-js-pagination'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import validationConfig from 'custom/config/validation.config.json'
import { DownloadReceiptSchema } from './../../schemas/others/downloadCenter/downloadReceipt'
const downloadReceipConfig = validationConfig['downloadCenter']['downloadReceipt']

export default function Receipts() {
  // const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [receiptsList, setReceiptsList] = useState([])
  const [receiptsDetails, setReceiptsDetails] = useState([])
  const [moduleType, setModuleType] = useState('FUNDTRANSFER')
  const [noRecords, setNoRecords] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPayment, setCurrentPayment] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10)
  const [formValues, setFormValues] = useState({
    fromDate: '',
    toDate: '',
  })

  const lastNTransaction = useCallback(async (page, values, module) => {
    try {
      setLoading(true)
      setReceiptsList([])
      setReceiptsDetails([])
      let reqParam = {
        module: module,
        fromDate: values?.fromDate || '',
        toDate: values?.toDate || '',
        page: page,
        size: pageLimit,
      }
      const response = await BeneficiaryTransferService.lastNTransaction(reqParam)
      if (response.status === 200) {
        setNoRecords(response.data['receiptDetails'].length === 0 ? true : false)
        setReceiptsDetails(response.data['receiptDetails'])
        setReceiptsList(response.data['receiptDetails'])
        setTotalRecords(response.data['totalItems'])
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    moduleType === 'FUNDTRANSFER'
      ? lastNTransaction(0, {}, 'FUNDTRANSFER')
      : lastNTransaction(0, {}, 'BILLPAYMENT')
  }, [])

  const paginationChange = useCallback(async (page) => {
    setCurrentPage(page)
    await lastNTransaction(page - 1, formValues, 'FUNDTRANSFER')
  }, [formValues])

  const paginationPaymentChange = useCallback(async (paymentPage) => {
    setCurrentPayment(paymentPage)
    await lastNTransaction(paymentPage - 1, formValues, 'BILLPAYMENT')
  }, [formValues])

  const onSearch = useCallback(async (values) => {
    if (values) {
      setFormValues({
        fromDate: values?.fromDate,
        toDate: values?.toDate,
      })
    }
    moduleType === 'FUNDTRANSFER'
      ? await lastNTransaction(0, values, 'FUNDTRANSFER')
      : await lastNTransaction(0, values, 'BILLPAYMENT')
  }, [moduleType])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='RECEIPTS' showEmptySpace={true} keyPath={'RECEIPTS'}>
      <div className='mb-4'>
        <Formik
          initialValues={formValues}
          validationSchema={DownloadReceiptSchema}
          onSubmit={onSearch}>
          {({ isSubmitting, errors, touched, handleChange, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isFromDateRequired']}
                    text={t(RECIPTS_KEYS.FORM_DATE)}
                    name='fromDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.fromDate}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isToDateRequired']}
                    text={t(RECIPTS_KEYS.TO_DATE)}
                    name='toDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.toDate}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='col-2 p-0' style={{ marginTop: '30px' }}>
                  <NeoButton type='submit' text={t(RECIPTS_KEYS.SEARCH)} mode='newDesign' />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className='receipt-section'>
        <div className='row tab-navbar'>
          <div className={moduleType === 'FUNDTRANSFER' ? 'col-6 selected' : 'col-6'}>
            <span
              onClick={() => {
                setModuleType('FUNDTRANSFER')
                lastNTransaction(0, formValues, 'FUNDTRANSFER')
                setCurrentPage(1)
              }}>
              {t(RECIPTS_KEYS.TRANSFERS)}
            </span>
          </div>
          <div className={moduleType === 'BILLPAYMENT' ? 'col-6 selected' : 'col-6'}>
            <span
              onClick={() => {
                setModuleType('BILLPAYMENT')
                lastNTransaction(0, formValues, 'BILLPAYMENT')
                setCurrentPayment(1)
              }}>
              {t(RECIPTS_KEYS.PAYMENTS)}
            </span>
          </div>
        </div>

        {loading && renderLoading()}

        {noRecords && <div className='no-data-found'>{t(RECIPTS_KEYS.NORECEIPTS)} </div>}

        {moduleType === 'FUNDTRANSFER' && receiptsList.length > 0 && (
          <TransferReceipts dataSource={receiptsList} />
        )}
        {moduleType === 'BILLPAYMENT' && receiptsDetails.length > 0 && (
          <PaymentReceipts dataSource={receiptsDetails} />
        )}
      </div>
      <div className='d-flex justify-content-center mb-5 mt-2'>
        {moduleType === 'FUNDTRANSFER'
          ? !loading &&
            receiptsList?.length > 0 && (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={pageLimit}
                totalItemsCount={totalRecords}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={paginationChange}
              />
            )
          : !loading &&
            receiptsDetails.length > 0 && (
              <Pagination
                activePage={currentPayment}
                itemsCountPerPage={pageLimit}
                totalItemsCount={totalRecords}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={paginationPaymentChange}
              />
            )}
      </div>
    </LayoutWithOutAccountCard>
  )
}
